import { render } from "./SearchProgram.vue?vue&type=template&id=1d3e7a67"
import script from "./SearchProgram.vue?vue&type=script&lang=js"
export * from "./SearchProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__